import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';

export const PAGE_HEADER = 'Run Instance > Configure ';

export const RETURN_TO_HOME = '/app/trm/run-instance';

export const CONFIRM_PROPS = {
  title: 'Do you want to leave this page/tab?',
  icon: <ExclamationCircleOutlined />,
  content: 'Changes you made may not be saved.',
  cancelText: 'Stay',
  okText: 'Leave'
};

export const CONFIRM_PROPS_ON_SAVE = (count) => ({
  title: 'Do you want to save changes?',
  icon: <ExclamationCircleOutlined />,
  content: `Changes done in ${count} Risk Indicator Thresholds will be Saved.`,
  cancelText: 'Cancel',
  okText: 'Save'
});

export const SCENARIO_FAILED = 'Configure Scenario trigger was failed';

export const SCENARIO_RI_FAILED =
  'Configure Scenario Risk Indicator trigger was failed';

export const SCENARIO_RI_PASSED = 'Risk indicator threshold saved successfully';

export const NO_CONFIG_SET = 'No Configuration Selected';
